export default {
    apiUrl: 'https://dsha-aw-api-stage.tangatek.net/api',
    env: 'stage',

    //  Auth Stuff
    authDomain: 'dsha-aw-stage.us.auth0.com',
    authAudience: 'https://dsha-aw-stage.tangatek.net/',
    authClientId: 'udAElRXSSl1QpI1yNDeY3IFVxGQ250jM',
}